import { ScrollArea } from '@components/ui/scroll-area';
import clsx from 'clsx';

interface LoadingSkeletonProps {
  className?: string;
}

export const LoadingSkeleton = ({ className }: LoadingSkeletonProps) => {
  return (
    <ScrollArea className="w-full">
      <div className={clsx('flex animate-pulse flex-col gap-y-3 pr-3', className)}>
        <div className="h-10 w-full rounded-lg border border-slate-300 bg-slate-200" />
        <div className="h-10 w-full rounded-lg border border-slate-300 bg-slate-200" />
        <div className="h-10 w-full rounded-lg border border-slate-300 bg-slate-200" />
        <div className="h-10 w-full rounded-lg border border-slate-300 bg-slate-200" />
        <div className="h-10 w-full rounded-lg border border-slate-300 bg-slate-200" />
      </div>
    </ScrollArea>
  );
};
